// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"4538d82a8d27282f3fc8","339":"dc92645d13601e80b33b"}[chunkId] + ".js";
};